import React, {useContext} from 'react';
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Zoom} from '@mui/material';
import Typography from '@mui/material/Typography';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import IconButton from '@mui/material/IconButton';
import {usersActionServices} from '../../services/UserServices';
import {SNACKBAR_OPEN} from '../../reducers';
import {DispatchContext} from '../../store';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Zoom style={{transitionDelay: '150ms'}} ref={ref} {...props}/>;
});

export default function DeleteDialog({open, handleAction, userId, users, setUsers}) {
  const dispatch = useContext(DispatchContext);

  const handleSubmit = () => {
    usersActionServices('delete', userId).then(res => {
      dispatch({
        type: SNACKBAR_OPEN,
        payload: {isNotify: true, severity: 'success', message: 'User deleted successfully'}
      });
      handleAction();
      let user = users?.find(user => user?.id === userId);
      let index = users?.indexOf(user);
      users?.splice(index, 1)
      setUsers(users);
    });
  }

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleAction}
      aria-describedby="alert-dialog-slide-description"
      fullWidth={true}
      maxWidth={'sm'}
    >
      <DialogTitle sx={{backgroundColor: '#f85454', height: 1}}/>
      <DialogContent className={'text-center'}>
        <IconButton sx={{backgroundColor: '#fce7e7', marginTop: 3}}>
          <ReportProblemIcon sx={{fontSize: 30, color: 'red'}}/>
        </IconButton>
        <Typography color={'#616B88'} sx={{fontSize: 25, marginTop: 2}} className={'text-bold text-center'}
                    fontWeight={700}>
          Are You Sure!
        </Typography>
        <Typography>
          This action cannot be undone.
        </Typography>
        <Typography>
          All values associated with this user will be lost.
        </Typography>
      </DialogContent>
      <div className={'header-divider'}/>
      <DialogActions>
        <Button onClick={handleAction} variant={'outlined'} color={'error'} className={'text-capitalize'}>Cancel</Button>
        <Button variant={'contained'} onClick={handleSubmit} className={'text-capitalize'}>Confirm</Button>
      </DialogActions>
    </Dialog>
  );
}